import ActionsMenu from './ActionsMenu.styled';

export default ActionsMenu;
